import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

const MyTrainingDetailIndexRevamp = () => {
  const { navigation } = useNavigation()
  const { trainingId } = useStrictParams<'trainingId'>()

  return (
    <>
      <Navigate
        replace
        to={navigation.myTrainings.revamp.detailsRevamp.view.overview.fullPath({
          trainingId: trainingId,
        })}
      />
    </>
  )
}

export default MyTrainingDetailIndexRevamp
